<template>
  <div v-if="dataBarChart?.labels?.length" class="feedbackChartsDays">
    <div v-if="dataLineChart?.labels?.length" class="feedbackChartsDays__line">
      <LineChart
        :id="'lineChart'"
        :data-line-chart="dataLineChart"
        :options-line-chart="optionsLineChart"
        :style="styleLineChart"
      />
    </div>
    <div v-if="dataBarChart?.labels?.length" class="feedbackChartsDays__bar">
      <BarChart
        :id="'barChart'"
        :data-bar-chart="dataBarChart"
        :options-bar-chart="optionsBarChart"
        :style="styleBarChart"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import { optionsLineChart, optionsBarChart } from './configs';

@Options({
  name: 'FeedbackChartsDays',
  props: ['dataLineChart', 'dataBarChart'],
  data() {
    return {
      optionsLineChart: optionsLineChart,
      optionsBarChart: optionsBarChart,
      height: 500,
      width: 1200
    };
  },
  computed: {
    styleLineChart() {
      return {
        height: `${this.height}px`,
        width: `${this.width}px`,
        position: 'relative'
      };
    },
    styleBarChart() {
      return {
        height: `${this.height}px`,
        width: `${this.width}px`,
        position: 'relative'
      };
    }
  }
})
export default class FeedbackChartsDays extends Vue {}
</script>

<style lang="scss" scoped>
.feedbackChartsDays {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 24px;
  .feedbackChartsDays__line {
    width: 70%;
    height: 350px;
    margin-bottom: 35px;
  }
  .feedbackChartsDays__bar {
    width: 70%;
  }
}
</style>
